export const myVodapayConstants = {
    commands: {
      GET_USER: "0",
      INIT_PAYMENT: "1",
      DOWNLOAD_TICKET: "2"
    },
    messages: {
      USER_INFO: "0",
      PAYMENT_SUCCESS: "1",
      PAYMENT_FAILURE: "2",      
    }
}

export const loadScript = () => {
  const scriptPath = "https://appx/web-view.min.js";
  let isFound = false;
  let scripts = document.getElementsByTagName("script");
  for (let i = 0; i < scripts.length; ++i) {
    const src = scripts[i].getAttribute('src');
    if (src && src === scriptPath) {
      isFound = true;
    }
  }

  if (!isFound) {
      let node = document.createElement('script');
      node.src = scriptPath;
      node.type = 'text/javascript';
      node.async = true;
      document.getElementsByTagName('head')[0].appendChild(node);
  }
}


export const miniAppsUrls = [
  "vodapay.quickbus.com",
  "vodapay-dev.quickbus.com",
  "vodapay-staging.quickbus.com",
  "jumia.quickbus.com",
  "jumia-dev.quickbus.com",
  "moya.quickbus.com",
  "moya-dev.quickbus.com",
  "quickbus.moyafree.co"
]